import { render, staticRenderFns } from "./famousSupplier.vue?vue&type=template&id=450a06f6&scoped=true&"
import script from "./famousSupplier.vue?vue&type=script&lang=js&"
export * from "./famousSupplier.vue?vue&type=script&lang=js&"
import style0 from "./famousSupplier.vue?vue&type=style&index=0&id=450a06f6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a06f6",
  null
  
)

export default component.exports